import { render, staticRenderFns } from "./RateSidebar.vue?vue&type=template&id=3f05a6cc&"
import script from "./RateSidebar.vue?vue&type=script&lang=js&"
export * from "./RateSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports